import { Link } from "react-router-dom";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "./ui/accordion";
import { AffiliateButton } from "./Affiliate";
import { NORD } from "../data/vpns";

export const FaqAccordion = ({ faqs }) => (
  <Accordion type="single" collapsible className="w-full" data-testid="faq-accordion">
    {faqs.map((f, i) => (
      <AccordionItem key={i} value={`faq-${i}`} className="border-slate-200">
        <AccordionTrigger
          data-testid={`faq-question-${i}`}
          className="text-left font-display text-base font-bold tracking-tight text-[#0F172A] hover:text-[#4687FF] hover:no-underline"
        >
          {f.q}
        </AccordionTrigger>
        <AccordionContent className="text-sm leading-relaxed text-slate-600">
          {f.a}
          {f.link && (
            <Link to={f.link.to} className="ml-1 font-semibold text-[#4687FF] underline underline-offset-4">
              {f.link.label} →
            </Link>
          )}
          {f.cta && (
            <div className="mt-4">
              <AffiliateButton href={NORD.link} testId={`faq-cta-${i}`} className="!px-5 !py-2.5 !text-xs">
                Try NordVPN — Our #1 Pick
              </AffiliateButton>
            </div>
          )}
        </AccordionContent>
      </AccordionItem>
    ))}
  </Accordion>
);
